// Add to your queries.js file
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from "libs";
import { UpdateModelNameParams } from 'types';
import { UPDATE_MODEL_DISPLAY_NAME } from 'api';

const useUpdateModelDisplayName = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ model_id, display_name }: UpdateModelNameParams) => {
        const response = await fetch(UPDATE_MODEL_DISPLAY_NAME, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ model_id, display_name }),
      });
      
      return response;
    },
    onSuccess: () => {
        queryClient.invalidateQueries({
            queryKey: ["models", { pageSize: 11, tags: [] }]
          });
    }
  });
};
export default useUpdateModelDisplayName